import { PaymentMethod } from "@types-runway/billing";

export const resolveSummaryPaymentMethod = (
  paymentMethods: PaymentMethod[],
  defaultPaymentMethodId: string | undefined
): PaymentMethod | undefined =>
  paymentMethods.find((paymentMethod) => paymentMethod.id === defaultPaymentMethodId) ??
  paymentMethods[0];
